export default __webpack_public_path__ + "static/media/guide_import_4.da7a16ce.jpg";